import { render, staticRenderFns } from "./ResultsSection.vue?vue&type=template&id=08b17f74&"
import script from "./ResultsSection.vue?vue&type=script&lang=ts&"
export * from "./ResultsSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports